import axios from 'axios';
import { getEnabledApps, loadApps } from './utility';
import Cookies from 'js-cookie';

// var jwt = require('jsonwebtoken');
import jwt_decode from 'jwt-decode';

class Singleton {
    static config = {
        accessToken: '',
        idToken: '',
        poolId: '',
        orgId: '',
        instance: '',
    };

    static cache = [];
    static isRefreshing = false;

    static refreshToken = async () => {
        let data = {
            auth_flow: 'REFRESH_TOKEN',
            client_id: Cookies.get('client_id'),
            refresh_token: Cookies.get('refresh_token'),
            user_pool: Cookies.get('user_pool'),
        };
        try {
            let response = await axios.post('/auth/signin', data);
            if (Singleton.config.instance) {
                Singleton.config.instance.defaults.headers.common[
                    'Authorization'
                    ] = `bearer ${response.data.AuthenticationResult.AccessToken}`;
            }
            clearTimeout(this.timer);
            this.timer = setTimeout(() => {
                Singleton.refreshToken();
            }, (response.data.AuthenticationResult.ExpiresIn - 10) * 1000);
            return response.data;
        } catch (error) {
            //Token refresh failed. Login again!
            Cookies.remove('refresh_token', {
                expires: 1,
                domain: '.veris.in',
                secure: true,
                sameSite: 'Strict',
            });
            window.location.href = '/';
        }
    };

    static createInstance = (payload, pathname) => {
        try {
            let idToken = jwt_decode(payload.AuthenticationResult.IdToken);
            let hostMemberObject = {
                name: idToken.name,
                contact: idToken.email || idToken.phone,
                memberId: payload.member,
            };
            if (payload.org) {
                localStorage.setItem('org_name', payload.org);
            }
            if (payload.roles) {
                localStorage.setItem('roles', JSON.stringify(payload.roles));
            }
            if (payload.contact_id) {
                localStorage.setItem('contact_id', payload.contact_id);
                localStorage.setItem('name', idToken.name);
            }
            window.mixpanel &&
            window.mixpanel.register({
                domain: window.location.host,
                user_id: `${idToken['cognito:username']} | ${payload.member}`,
                name: idToken.name,
                username: idToken['cognito:username'],
                org_id: payload.orgId,
                org_name: payload.org,
            });
            window.fcWidget &&
            window.fcWidget.init({
                token: '12eb87fc-ea7d-47e4-9378-7b249068eccc',
                host: 'https://wchat.freshchat.com',
                externalId: `${payload.orgId} -- ${payload.org}`,
                firstName: idToken.name.split(' ')[0],
                lastName: idToken.name.split(' ')[1],
                email: idToken.email,
                config: {
                    headerProperty: {
                        direction: 'ltr',
                    },
                },
            });
            window.FreshWidget &&
            window.FreshWidget.init('', {
                loadOnEvent: 'immediate',
                queryString: '&widgetType=popup',
                utf8: '✓',
                token: '12eb87fc-ea7d-47e4-9378-7b249068eccc',
                widgetType: 'popup',
                buttonType: 'text',
                buttonText: 'Feedback',
                buttonColor: '#F9F9F9',
                buttonBg: '#0087C3',
                alignment: '4',
                offset: '80vh',
                formHeight: '500px',
                url: 'https://verishelp.freshdesk.com',
                buttonPosition: 'left',
            });

            Singleton.config.accessToken =
                payload.AuthenticationResult.AccessToken;
            Singleton.config.idToken = payload.AuthenticationResult.IdToken;
            Singleton.config.poolId = payload.poolId;
            Singleton.config.orgId = payload.orgId;
            Singleton.config.appClient = payload.clientIdInUse;
            Singleton.config.genericServerUrl = payload.baseUrl;
            Singleton.config.roles = payload.roles;

            if (payload.baseUrl && payload.domain && payload.cookiesUrls) {
                let domains = payload.cookiesUrls
                    ? payload.cookiesUrls.split(',')
                    : [];
                domains.push(payload.domain);
                domains.push(payload.baseUrl);
                Cookies.set('domains', domains.join(','), {
                    expires: 1,
                    domain: '.veris.in',
                    secure: true,
                    sameSite: 'Strict',
                });
                Cookies.set('genericServerUrl', payload.baseUrl, {
                    expires: 1,
                    domain: '.veris.in',
                    secure: true,
                    sameSite: 'Strict',
                });
                Cookies.set('domainServerUrl', payload.domain, {
                    expires: 1,
                    domain: '.veris.in',
                    secure: true,
                    sameSite: 'Strict',
                });
            }
            if (
                payload.AuthenticationResult &&
                payload.AuthenticationResult.RefreshToken
            )
                Cookies.set(
                    'refresh_token',
                    payload.AuthenticationResult.RefreshToken,
                    {
                        expires: 1,
                        domain: '.veris.in',
                        secure: true,
                        sameSite: 'Strict',
                    },
                );
            Cookies.set('client_id', payload.clientIdInUse, {
                expires: 1,
                domain: '.veris.in',
                secure: true,
                sameSite: 'Strict',
            });
            Cookies.set('org_id', payload.orgId, {
                expires: 1,
                domain: '.veris.in',
                secure: true,
                sameSite: 'Strict',
            });
            Cookies.set('member_id', payload.member, {
                expires: 1,
                domain: '.veris.in',
                secure: true,
                sameSite: 'Strict',
            });
            Cookies.set('user_pool', payload.pool.id, {
                expires: 1,
                domain: '.veris.in',
                secure: true,
                sameSite: 'Strict',
            });
            Cookies.set('pool_id', payload.poolId, {
                expires: 1,
                domain: '.veris.in',
                secure: true,
                sameSite: 'Strict',
            });
            Cookies.set('token', payload.token, {
                expires: 1,
                domain: '.veris.in',
                secure: true,
                sameSite: 'Strict',
            });
            Cookies.set(
                'accessToken',
                payload.AuthenticationResult.AccessToken,
                {
                    expires: 1,
                    domain: '.veris.in',
                    secure: true,
                    sameSite: 'Strict',
                },
            );

            Singleton.config.instance = axios.create({
                headers: {
                  "X-Content-Type-Options": "nosniff",
                  "Referrer-Policy": "strict-origin",
                  "X-XSS-Protection": "1; mode=block",
                  "X-Content-Security-Policy": "default-src 'self'",
                  "X-Frame-Options": "SAMEORIGIN",
                  "Strict-Transport-Security": "max-age=31536000; includeSubDomains",
                  "Content-Security-Policy": "default-src 'self'",
                  "Permissions-Policy": "default-src 'self'",
                },
              });
            Singleton.config.instance.interceptors.response.use(
                (response) => {
                    return response;
                },
                async (error) => {
                    if (error.response.status === 401) {
                        //Refresh token fail safe
                        try {
                            if (!Singleton.isRefreshing) {
                                Singleton.isRefreshing = true;
                                Singleton.cache.push(error.config);
                                let response = await Singleton.refreshToken();
                                Singleton.config.accessToken =
                                    response.AuthenticationResult.AccessToken;
                                Singleton.config.idToken =
                                    response.AuthenticationResult.IdToken;
                                Singleton.cache.forEach((request) => {
                                    request.headers.Authorization = `bearer ${response.AuthenticationResult.AccessToken}`;
                                    axios(request);
                                });
                                Singleton.cache = [];
                                Singleton.isRefreshing = false;
                            } else {
                                Singleton.cache.push(error.config);
                            }
                        } catch (error) {
                            //Token refresh failed. Login again!
                            Cookies.remove('refresh_token', {
                                expires: 1,
                                domain: '.veris.in',
                                secure: true,
                                sameSite: 'Strict',
                            });
                            window.location.href = '/';
                        }
                    } else {
                        throw error;
                    }
                },
            );
            Singleton.config.instance.defaults.headers.common[
                'Authorization'
                ] = `bearer ${payload.AuthenticationResult.AccessToken}`;
            Singleton.config.instance.defaults.headers.common[
                'pool'
                ] = `pool_${payload.poolId}`;

            if (!this.timer) {
                setTimeout(() => {
                    this.refreshToken();
                }, (payload.AuthenticationResult.ExpiresIn - 10) * 1000);
            }

            let config = {
                headers: {
                    Authorization: `bearer ${payload.AuthenticationResult.AccessToken}`,
                    pool: `pool_${payload.poolId}`,
                },
            };

            getEnabledApps(payload.orgId, config)
                .then((response) => {
                    response = response.filter((ele) => ele.version !== 'v5');
                    let apps = [];
                    let defaultAPP = '/vms-v4';
                    response.forEach((ele) => {
                        if (ele.default) {
                            defaultAPP = ele.url;
                        }
                        if (!apps.includes(ele.app)) {
                            apps.push(ele.app);
                        }
                    });
                    localStorage.setItem('default-app', defaultAPP);
                    apps.unshift('navigation');
                    loadApps(
                        apps,
                        () => {
                            return pathname ? pathname : defaultAPP;
                        },
                        response,
                        hostMemberObject,
                    );
                })
                .catch((error) => {
                    throw error;
                });
        } catch (error) {
            throw error;
        }
    };
}

export default Singleton;
